import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/utils.js';
const scopeFill = {
    platform: 'bg-scope-platform-fill text-scope-platform-text',
    org: 'bg-scope-org-fill text-scope-org-text',
    tenant: 'bg-scope-tenant-fill text-scope-tenant-text',
    neutral: 'bg-muted text-muted-foreground',
};
const sizes = { sm: 'size-6 text-2xs', md: 'size-8 text-xs', lg: 'size-10 text-sm' };
export function Avatar({ name, src, scope = 'neutral', size = 'md', className, }) {
    const initial = (name ?? '?').trim().charAt(0).toUpperCase() || '?';
    const [broken, setBroken] = React.useState(false);
    React.useEffect(() => { setBroken(false); }, [src]);
    if (src && !broken) {
        return (_jsx("img", { src: src, alt: "", "aria-hidden": true, onError: () => setBroken(true), className: cn('inline-block shrink-0 rounded-full object-cover', sizes[size], className) }));
    }
    return (_jsx("span", { "aria-hidden": true, className: cn('inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold', scopeFill[scope], sizes[size], className), children: initial }));
}
